import { createSelector } from 'reselect'

import { getFilterForSave } from '../helpers/getFilterForSave'

import { selectComposedReportState } from './selectComposedReportState'

export const selectFilterForSave = createSelector(
  [selectComposedReportState],
  ({
    geo,
    partnersInScope,
    scopeValue,
    pbms,
    products,
    managers,
    specializations,
    acknowledged,
    amplifyMembership,
    fYear,
    partnersType,
    isAcknowledged,
  }) => {
    return getFilterForSave({
      geo,
      partnersInScope,
      scopeValue,
      pbms,
      products,
      managers,
      specializations,
      acknowledged,
      amplifyMembership,
      fYear,
      partnersType,
      isAcknowledged,
    })
  }
)
